import { Component, OnInit, ViewChild, Renderer, OnDestroy } from '@angular/core';
import * as moment from 'moment'; 
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

/* servicio */
import { InformesService } from 'app/services/informes.service';

/* modals */
import { ModaltitularesComponent } from 'app/modals/apoyo-usuario/modaltitulares/modaltitulares.component';
import { map } from 'rxjs/operators';

@Component ({
  selector: 'app-titulares',
  templateUrl: './titulares.component.html',
  styleUrls: ['./titulares.component.scss']
})
export class TitularesComponent implements OnInit, OnDestroy {

  private fechaFinal: string;
  private fechaInicial: string;
  public fecha_final: any = moment();
  public fecha_inicial:any = moment("2014-03-22");
  public spinner: boolean;
  private ps;

  //Data Table
  public dataTable_options;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>
  
  constructor(private _informe: InformesService, private _renderer:Renderer, private dialog: MatDialog) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.tableOpt = [];
  }

  ngOnInit() {
     this.dataTable_options = {
      columns: [
        {
          title: ''
        },
        {
          title: 'PromedioServAde',
          data:'porcentaje'
        },
        {
          title: 'Total servicios',
          data: 'total_servicios'
        },
        {
          title: 'Meses',
          data: 'PerTiempoTit'
        },
        {
          title: 'Documento',
          data: 'titnit'
        },
        {
          title: 'Nombre',
          render: (data, type, row, meta)=>{
            return `<a titnom="${row.ID_Titular}">${data}</a>`
          }
        },
        {
          title: 'Radicado',
          data: 'grugru'
        },
        {
          title: 'ID Titular',
          data: 'ID_Titular'
        }, 
        {
          title: 'ID Grupo',
          data: 'ID_Grupo'
        },
        {
          title: 'Fecha Inicio',
          data: 'cobini'
        },
        {
          title: 'Beneficiarios',
          data: 'beneficiarios'
        },
        {
          title:'ServAdeTotal',
          data:'servicio_adecuado'
        }
      ]
    } 
    this.spinner = false; 
  }

  public buscarTitulares(){
    this.spinner = true;

    this.fechaInicial = moment(this.fecha_inicial).get('year').toString()+"-"+(moment(this.fecha_inicial).get('month')+1).toString()+"-"+moment(this.fecha_inicial).get('date').toString();
    this.fechaFinal = moment(this.fecha_final).get('year').toString() +"-"+(moment(this.fecha_final).get('month')+1).toString() +"-"+ moment(this.fecha_final).get('date').toString();

    this._informe.ApoyoUsuariosTitulares(this.fechaInicial, this.fechaFinal)
      .pipe(
        map((succ:Array<any>)=>{
            let data=succ['resultado'].filter((succ)=>{
            return succ['ApoyoUsuariosTit']== 1;
          })
          return data;
        }
      ))
      .subscribe((data:any) => {
        this.spinner = false;
        this.renderer();
        this.tableOpt = data;
      });
  } 

  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    this._renderer.listenGlobal('document', 'click', (e) => {
      e.stopPropagation();

      if(e.target.hasAttribute('titnom')){

        this.dialog.open(ModaltitularesComponent,{
          width:'99%',
          height:'90%',
          data: {
            titular_doc: e.target.getAttribute('titnom'),
            fechaInicial:this.fechaInicial, 
            fechaFinal:this.fechaFinal
          }
        });

      }

    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

}
